import type { Product } from '~/core/entities/strapi/Product';
import type { ApiStrapiProduct } from '../strapi/product/types';
import { categoryIdentifier, productIdentifier, canPurchaseProduct } from '~/utils/shop';
export class CartService {
  private static formatProduct(product: ApiStrapiProduct): Product {
    return {
      id: product.id,
      slug: productIdentifier(product),
      title: product.title,
      price: Number(product.price),
      image_url:
        product.image?.file?.formats?.thumbnail?.url ||
        product.image?.file?.url ||
        product.image_url ||
        '',
      category: {
        slug: product.category?.slug || '',
        title: product.category?.name || '',
        route: categoryIdentifier(product.category),
      },
    };
  }
  static addToCart(product: ApiStrapiProduct) {
    if (canPurchaseProduct(product)) useCartStore().add(this.formatProduct(product));
  }
}
